var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-xl-6 col-sm-11 col-md-11 mx-auto"},[_c('h1',{staticClass:"display-3 my-4"},[_vm._v(_vm._s(_vm.$t('landing.404')))]),_c('img',{attrs:{"id":"gif","src":require("../assets/404.gif")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }